export const contactsData = {
    email: 'kelebetaengida@gmail.com',
    phone: '+1 206 307 7869',
    address: 'Seattle, WA, United States',

    sheetAPI: 'https://docs.google.com/spreadsheets/d/1eFVe71WPC5SvmfKePvolwaj7WnrAaAE0EfNfIOksn6k/edit?usp=sharing'
}